import { Injectable } from '@angular/core'

declare var require: any
// const themeA = require('../../modules/shared/styles/themes/theme-a.scss')
// const themeB = require('../../modules/shared/styles/themes/theme-b.scss')
// const themeC = require('../../modules/shared/styles/themes/theme-c.scss')
// const themeD = require('../../modules/shared/styles/themes/theme-d.scss')
// const themeE = require('../../modules/shared/styles/themes/theme-e.scss')
// const themeF = require('../../modules/shared/styles/themes/theme-f.scss')
// const themeG = require('../../modules/shared/styles/themes/theme-g.scss')
// const themeH = require('../../modules/shared/styles/themes/theme-h.scss')

@Injectable({
  providedIn: 'root',
})
export class ThemesService {
  styleTag: any
  defaultTheme: string

  constructor() {
    // this.defaultTheme = (window as any).env.Theme
    // this.createStyle()
    // this.setTheme(this.defaultTheme)
  }

  private createStyle() {
    const head = document.head || document.getElementsByTagName('head')[0]
    this.styleTag = document.createElement('style')
    this.styleTag.type = 'text/css'
    this.styleTag.id = 'appthemes'
    head.appendChild(this.styleTag)
  }

  setTheme(name) {
    switch (name) {
      // case 'A':
      //   this.injectStylesheet(themeA)
      //   break
      // case 'B':
      //   this.injectStylesheet(themeB)
      //   break
      // case 'C':
      //   this.injectStylesheet(themeC)
      //   break
      // case 'D':
      //   this.injectStylesheet(themeD)
      //   break
      // case 'E':
      //   this.injectStylesheet(themeE)
      //   break
      // case 'F':
      //   this.injectStylesheet(themeF)
      //   break
      // case 'G':
      //   this.injectStylesheet(themeG)
      //   break
      // case 'H':
      //   this.injectStylesheet(themeH)
      //   break
    }
  }

  // injectStylesheet(css) {
  //   this.styleTag.innerHTML = css.default
  // }

  getDefaultTheme() {
    return this.defaultTheme
  }
}
